/*
 * Sales-only instant task helpers: live-instant ordering and the pop-up's
 * short rule labels. The elapsed timer and expiry wording are shared with
 * other queues in util_components/instant_alert/instant_timer.
 */

import { is_terminal as isTerminal } from './overdue';

// The slice of a list row / relay item the instant helpers read.
export interface InstantItem {
  status?: string;
  is_instant?: boolean;
}

// An instant task still worth a timer: terminal work (submitted, auto-closed,
// auto-completed) is finished, so its urgency is history.
export const is_instant_live = (item: InstantItem | null | undefined): boolean =>
  !!item && !!item.is_instant && !isTerminal(item);

// Index of the first row outside the live-instant block, the list's leading
// sort key (goserver listLiveExpr); -1 when every row is live instant.
export const first_standard_index = (
  rows: Array<InstantItem | null | undefined> | null | undefined
): number => (rows || []).findIndex((item) => !is_instant_live(item));

// The wireframe's pop-up wording for the instant rules it names; every other
// type keeps the server's rule label.
const SHORT_LABELS: Record<string, string> = {
  FRESH_LEAD: 'New Sign-up',
  NO_BOOK: 'No Booking',
  LOGIN_ISSUE: 'Login Issue',
  CHURNED_MEMBER_LOGIN: 'Churned Member',
  LEAD_OTP_NOT_VERIFIED: 'Unverified Lead',
  BOOKING_ERROR: 'Booking Error'
};

export const short_label = (
  taskType: string | null | undefined,
  taskLabel?: string | null
): string => (taskType && SHORT_LABELS[taskType]) || taskLabel || taskType || '';
